// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"74759806","189":"1a7fd107","244":"24b104c0","255":"d135831b","465":"1a61772c","476":"87087b09","870":"53a09ffe"}[chunkId] + ".chunk.js";
};